// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset some basic elements */
* {
    /* margin: 0;
    padding: 0; */
    box-sizing: border-box;
  }
  
  body {
    font-family: Arial, sans-serif;
    background-color: #f4f4f4;
    color: #333;
  }
  
  .AdminDB {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  
  .AdminNav {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 20px;
    flex: 1 1;
  }
  
  .left { 
    position: sticky;
    top: 20px; 
    width: 250px;
    background-color: #ffcc00;
    padding: 20px;
    color: #333;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    align-self: flex-start;
    transition: width 0.3s, padding 0.3s;
  }
  
  .left.collapsed {
    width: 80px;
    padding: 20px 10px;
  }
  
  .left h2 {
    margin-bottom: 20px;
  }
  
  .left.collapsed h2 {
    display: none;
  }
  
  .left ul {
    list-style: none;
  }
  
  .left li {
    margin-bottom: 10px;
  }
  
  .left.collapsed ul {
    display: none;
  }
  
  .toggleButton {
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 20px;
    width: 100%;
  }
  
  .listItem {
    text-decoration: none;
    color: #333;
    padding: 10px 15px;
    display: block;
    border-radius: 4px;
    transition: background-color 0.3s, color 0.3s;
  }
  
  .listItem:hover {
    background-color: #e6b800;
    color: #fff;
  }
  
  .listItem.active {
    background-color: #cc9900;
    color: #fff;
  }
  
  .right {
    flex: 1 1;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  

/* 

.AdminNav{

    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0 20px;
}

.left{
    position: sticky;
    top: 30px;
    width: 300px;
 
    background-color: goldenrod;
    padding-top: 20px;
    color: black;
    color: initial;
    height: 40vh;
}
.left h2{

     margin-left: 20px;
}

.AdminNav{
   
}

.listItem{
    text-decoration: none;
} */`, "",{"version":3,"sources":["webpack://./src/Pages/AdminDB/AdminDB.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI;iBACa;IACb,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,aAAa;IACb,SAAO;EACT;;EAEA;IAEE,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,sBAAsB;IACtB,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;EAC1C;;;AAGF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG","sourcesContent":["/* Reset some basic elements */\n* {\n    /* margin: 0;\n    padding: 0; */\n    box-sizing: border-box;\n  }\n  \n  body {\n    font-family: Arial, sans-serif;\n    background-color: #f4f4f4;\n    color: #333;\n  }\n  \n  .AdminDB {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n  }\n  \n  .AdminNav {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding: 20px;\n    flex: 1;\n  }\n  \n  .left {\n    position: -webkit-sticky; \n    position: sticky;\n    top: 20px; \n    width: 250px;\n    background-color: #ffcc00;\n    padding: 20px;\n    color: #333;\n    height: auto;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    align-self: flex-start;\n    transition: width 0.3s, padding 0.3s;\n  }\n  \n  .left.collapsed {\n    width: 80px;\n    padding: 20px 10px;\n  }\n  \n  .left h2 {\n    margin-bottom: 20px;\n  }\n  \n  .left.collapsed h2 {\n    display: none;\n  }\n  \n  .left ul {\n    list-style: none;\n  }\n  \n  .left li {\n    margin-bottom: 10px;\n  }\n  \n  .left.collapsed ul {\n    display: none;\n  }\n  \n  .toggleButton {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-bottom: 20px;\n    width: 100%;\n  }\n  \n  .listItem {\n    text-decoration: none;\n    color: #333;\n    padding: 10px 15px;\n    display: block;\n    border-radius: 4px;\n    transition: background-color 0.3s, color 0.3s;\n  }\n  \n  .listItem:hover {\n    background-color: #e6b800;\n    color: #fff;\n  }\n  \n  .listItem.active {\n    background-color: #cc9900;\n    color: #fff;\n  }\n  \n  .right {\n    flex: 1;\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n\n/* \n\n.AdminNav{\n\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding: 0 20px;\n}\n\n.left{\n    position: sticky;\n    top: 30px;\n    width: 300px;\n \n    background-color: goldenrod;\n    padding-top: 20px;\n    color: black;\n    color: initial;\n    height: 40vh;\n}\n.left h2{\n\n     margin-left: 20px;\n}\n\n.AdminNav{\n   \n}\n\n.listItem{\n    text-decoration: none;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
